import React from "react";
import cn from "classnames";
import Lang from "../../helpers/Lang";
import SocialSharing from "../SocialSharing/SocialSharing";

class CarouselControls extends React.Component {
  render() {
    let prevSlide = this.props.prevSlide;
    let nextSlide = this.props.nextSlide;

    if (this.props.apiObjectError) {
      prevSlide, (nextSlide = []);
    }

    return (
      <div className="gallery-carousel-navigation">
        <button
          type="button"
          className={cn("gallery-carousel-prev", {
            "gallery-carousel-hidden-button": !prevSlide[0],
          })}
          onClick={prevSlide[1]}
          ref="prev"
        >
          <span className="visuallyhidden">{Lang.get("previous")}</span>
        </button>
        <div className="gallery-carousel-center-buttons">
          {this.props.showFullScreenButton && (
            <button
              type="button"
              className="gallery-carousel-full-screen"
              onClick={this.props.handleFullscreenClick}
            >
              <span className="visuallyhidden">{Lang.get("fullscreen")}</span>
            </button>
          )}
          {this.props.showDownloadButton && (
            <a
              href={this.props.imgSrcDownload}
              className="button gallery-carousel-download"
              download
            >
              <span className="visuallyhidden">{Lang.get("download")}</span>
            </a>
          )}
          <SocialSharing
            url={window.location}
            additionalLinkCssClasses={"gallery-carousel-share"}
            additionalMenuCssClasses={"social-sharing-list__open-downwards"}
            hideSharingText={true}
          />
        </div>
        <button
          type="button"
          className={cn("gallery-carousel-next", {
            "gallery-carousel-hidden-button": !nextSlide[0],
          })}
          onClick={nextSlide[1]}
          ref="next"
        >
          <span className="visuallyhidden">{Lang.get("next")}</span>
        </button>
      </div>
    );
  }
}

export default CarouselControls;
